import {
  Dialog,
  DialogActions as MuiDialogActions,
  DialogContent,
  DialogTitle as MuiDialogTitle,
  Typography,
  IconButton,
  Box,
  DialogActions,
  TextField,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { WithStyles } from '@material-ui/core/styles';
import { Close } from '@material-ui/icons';
import { Button, SelectField } from '@roc/ui';
import { makeStyles } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import React from 'react';

export const estimatedGUExperienceOptions = [
  { label: 'Experience Score 0', value: 0 },
  { label: 'Experience Score 3 (1-2 Ground Up Construction)', value: 3 },
  { label: 'Experience Score 4 (3-4 Ground Up Construction)', value: 4 },
  { label: 'Experience Score 5 (5+ Ground Up Construction)', value: 5 },
  { label: 'Experienced Developer (20+ Ground Up Construction)', value: 6 },
];

export const estimatedFFExperienceOptions = [
  { label: 'Experience Score 0', value: '' },
  { label: 'Experience Score 1 (No Experience)', value: 1 },
  { label: 'Experience Score 2 (1-2 Investment Properties)', value: 2 },
  { label: 'Experience Score 3 (3-4 Investment Properties)', value: 3 },
  { label: 'Experience Score 4 (5-9 Investment Properties)', value: 4 },
  { label: 'Experience Score 5 (10+ Investment Properties)', value: 5 },
];

export const estimatedRentalExperienceOptions = [
  { label: 'Experience Score 0', value: '' },
  { label: 'Experience Score 1 (1-2 Rentals)', value: 1 },
  { label: 'Experience Score 2 (3-4 Rentals)', value: 2 },
  { label: 'Experience Score 3 (5-9 Rentals)', value: 3 },
  { label: 'Experience Score 4 (10-49 Rentals)', value: 4 },
  { label: 'Experience Score 5 (50+ Rentals)', value: 5 },
];

export const borrowerExpValuesTerm = [
  { label: 'Experience Score 0', value: 0 },
  { label: 'Experience Score 1 (No Experience)', value: 1 },
  { label: 'Experience Score 2 (1-2 Investment Properties)', value: 2 },
  { label: 'Experience Score 3 (3-4 Investment Properties)', value: 3 },
  { label: 'Experience Score 4 (5-9 Investment Properties)', value: 4 },
  { label: 'Experience Score 5 (10+ Investment Properties)', value: 5 },
];

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

const styles = (theme: Theme) =>
  createStyles({
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography {...other}>
      <Typography variant="h4">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <Close />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const EditBorrowerExperienceModal = observer(
  ({ open, handleClose, store, handleSave, dialogClasses = undefined }) => {
    const handleDialogClose = e => {
      handleClose(e);
    };

    const handleBridgeExperienceChange = (value) => {
      store.setExperience(Number(value))
    }

    const handleRentalExperienceChange = (value) => {
      store.setRentalExperience(Number(value))
    }

    const handleRentalMfExperienceChange = (value) => {
      store.setRentalMfExperience(Number(value))
    }

    const handleGroundUpExperienceChange = (value) => {
      store.setGroundUpExperience(Number(value))
    }

    return (
      <div>
        <Dialog
          disableEscapeKeyDown
          open={open}
          classes={dialogClasses}
          onClose={handleDialogClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle
            id="form-dialog-title"
            onClose={() => handleDialogClose(null)}
          >
            {'Edit Borrower Experience'}
          </DialogTitle>
          <DialogContent style={{ width: '600px' }}>
            <Box>
              <Typography variant="subtitle2" style={{ color: '#757575', fontWeight: 600 }}>
                Fix and Flip / Stabilized Bridge
              </Typography>
              <SelectField
                standaloneLabel
                name={'borrowerExp'}
                value={store.baseballCardDetails?.bridgeExp}
                options={estimatedFFExperienceOptions}
                onChange={handleBridgeExperienceChange}
                variant="outlined"
                fullWidth
                testId="borrowerExp"
                style={{ marginBottom: '20px', width: '100%' }}
              />
            </Box>
            <Box>
              <Typography variant="subtitle2" style={{ color: '#757575', fontWeight: 600 }}>
                Ground Up Construction
              </Typography>
              <SelectField
                standaloneLabel
                name={'borrowerExp'}
                value={store.baseballCardDetails?.groundupExperience}
                options={estimatedGUExperienceOptions}
                onChange={handleGroundUpExperienceChange}
                variant="outlined"
                fullWidth
                testId="borrowerExp"
                style={{ marginBottom: '20px', width: '100%' }}
              />
            </Box>
            <Box>
              <Typography variant="subtitle2" style={{ color: '#757575', fontWeight: 600 }}>
                Term
              </Typography>
              <SelectField
                standaloneLabel
                name={'borrowerExp'}
                value={store.baseballCardDetails?.rentalExp}
                options={estimatedRentalExperienceOptions}
                onChange={handleRentalExperienceChange}
                variant="outlined"
                fullWidth
                testId="borrowerExp"
                style={{ marginBottom: '20px', width: '100%' }}
              />
            </Box>
            <Box>
              <Typography variant="subtitle2" style={{ color: '#757575', fontWeight: 600 }}>
                Comments
              </Typography>
              <TextField
                style={{ width: '100%', marginBottom: '20px' }}
                variant='outlined'
                multiline={true}
                minRows={3}
                onChange={e => store.setExperienceComment(e.target.value)}
                value={
                  store.baseballCardDetails
                    ? store.baseballCardDetails.experienceComment
                    : ''
                }
              />
            </Box>
          </DialogContent>
          <DialogActions disableSpacing>
            <Button onClick={handleDialogClose} color="primary" testId="cancel">
              Cancel
            </Button>
            <Button
              onClick={e => {
                handleSave();
                handleDialogClose(e);
              }}
              color="primary"
              variant="contained"
              testId="save"
            >
              {'Apply Changes'}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
);

export default EditBorrowerExperienceModal;